import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock } from 'lucide-react';
import { FadeInUp } from '../animations';

const BlogPostHeader = ({ post }) => (
  <section className="relative py-24 lg:py-32 bg-[#071E45] text-white">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <FadeInUp>
        <Link
          to="/blog"
          className="inline-flex items-center gap-1 text-xs tracking-wider uppercase text-white/50 hover:text-white/80 transition-colors mb-8"
        >
          <ArrowLeft size={14} /> Back to Blog
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <span className="text-xs font-semibold text-white/80 tracking-wider uppercase px-3 py-1 border border-white/20">
            {post.category}
          </span>
          <span className="flex items-center gap-1 text-xs text-white/50">
            <Calendar size={12} /> {post.date}
          </span>
          <span className="flex items-center gap-1 text-xs text-white/50">
            <Clock size={12} /> {post.readTime}
          </span>
        </div>
        <h1
          className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.15] mb-4"
          style={{ fontFamily: 'Cabinet Grotesk' }}
          data-testid="blog-post-title"
        >
          {post.title}
        </h1>
        <p className="text-base text-white/60 leading-relaxed max-w-3xl">{post.excerpt}</p>
      </FadeInUp>
    </div>
  </section>
);

export default BlogPostHeader;
